// Setting
export const DRAWER_COLLAPSED = "drawerCollapsed";
export const FETCH_CONNECTED = "fetchConnected";

// Auth
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const CHECK_AUTH = "checkAuth";
export const RESET_PASSWORD = "resetPassword";
export const FORCE_LOGOUT = "forceLogout";
export const REFRESH_TOKEN = "refreshToken";

// Nav
export const SET_ACTIVE_NAV = "setActiveNav";
export const PURGE_NAV = "purgeNav";

// Profile
export const FETCH_PROFILE = "fetchProfile";

// Lov
export const FETCH_LOV_ZIPCODE = "fetchLovZipCode";
